
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import * as Papi from '@app/papi';
import { Observable } from 'rxjs';

import { isNil } from 'lodash';

@Injectable()
export class RoleGuard {

	constructor(private router: Router, private papi: Papi.Service) {
	}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
		if (!this.isRememberMeValid()) {
			this.router.navigate(['/login']);
			return false;
		}
		return this.papi.authorize(route.data.role).pipe(map((verified: boolean) => {
			if (!verified) {
				return this.errorOut(state);
			}
			return verified;
		}));
	}

	private isRememberMeValid(): boolean {
		const sessionStorageRememberMe = sessionStorage.getItem('rememberMe');
		const localStorageRememberMe = localStorage.getItem('rememberMe');

		// If sessionStorage is empty and localStorage explicitly says false → redirect
		if (sessionStorageRememberMe === null && localStorageRememberMe === 'false') {
			return false;
		}

		// Otherwise (true or null) → valid
		return true;
	}


	errorOut(state: RouterStateSnapshot) {
		this.router.navigate(['/']);
		return false;
	}
}
